import {ActionButton, useIsMobile} from '@ark/web';
import {Box, Dialog, Stack, Typography, useTheme} from '@mui/material';

type LogoutConfirmationModalProps = {
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  title: string;
  description: string;
  onConfirm: () => void;
};

export const LogoutConfirmationModal = ({
  modalOpen,
  setModalOpen,
  title,
  description,
  onConfirm,
}: LogoutConfirmationModalProps) => {
  const theme = useTheme();
  const isMobile = useIsMobile('md');

  return (
    <Dialog
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          maxWidth: isMobile ? '100%' : 480,
          borderRadius: isMobile ? 0 : 2,
          maxHeight: isMobile ? '100%' : '90vh',
        },
      }}
    >
      <Box sx={{overflow: 'auto', flex: 1}}>
        <Box sx={{px: isMobile ? 2 : 4, pt: isMobile ? 3 : 4, pb: 2}}>
          <Stack spacing={2}>
            <Typography
              variant="h6"
              sx={{
                fontSize: 16,
                fontWeight: 600,
                lineHeight: 1,
                letterSpacing: '0.15px',
                color: theme.palette.text.primary,
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                fontSize: 14,
                color: theme.palette.text.secondary,
              }}
            >
              {description}
            </Typography>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 2,
                paddingTop: 2,
              }}
            >
              <ActionButton
                variant="outline"
                onClick={() => setModalOpen(false)}
                data-attr="logout-confirmation-cancel"
                sx={{
                  px: 1.5,
                  py: 0.5,
                }}
              >
                Cancel
              </ActionButton>
              <ActionButton
                variant="primary"
                onClick={onConfirm}
                data-attr="logout-confirmation-confirm"
                loading={false}
              >
                {title}
              </ActionButton>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Dialog>
  );
};
